import { render, staticRenderFns } from "./establecimientosComercio.vue?vue&type=template&id=0c9468f4&"
import script from "./establecimientosComercio.vue?vue&type=script&lang=js&"
export * from "./establecimientosComercio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports